/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PatientFileDownloadUrlDto } from '../models/PatientFileDownloadUrlDto';
import type { PatientFileDto } from '../models/PatientFileDto';
import type { SavePatientFileVisibilityDto } from '../models/SavePatientFileVisibilityDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { request as __request } from '../core/request';

export class PatientFileService {

    /**
     * List uploaded medical records for a referral
     * @param referralId
     * @returns PatientFileDto
     * @throws ApiError
     */
    public static patientFileControllerList(
        referralId: string,
    ): CancelablePromise<Array<PatientFileDto>> {
        return __request({
            method: 'GET',
            path: `/referral/${referralId}/patient-files`,
        });
    }

    /**
     * Save which medical records are visible to the site
     * @param referralId
     * @param requestBody
     * @returns PatientFileDto
     * @throws ApiError
     */
    public static patientFileControllerSaveVisibility(
        referralId: string,
        requestBody: SavePatientFileVisibilityDto,
    ): CancelablePromise<Array<PatientFileDto>> {
        return __request({
            method: 'PUT',
            path: `/referral/${referralId}/patient-files/visibility`,
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Download all medical records for a referral as a zip
     * @param referralId
     * @returns any
     * @throws ApiError
     */
    public static patientFileControllerDownloadArchive(
        referralId: string,
    ): CancelablePromise<any> {
        return __request({
            method: 'GET',
            path: `/referral/${referralId}/patient-files/archive`,
        });
    }

    /**
     * Create a short-lived download URL for one record
     * @param referralId
     * @param fileId
     * @returns PatientFileDownloadUrlDto
     * @throws ApiError
     */
    public static patientFileControllerDownloadUrl(
        referralId: string,
        fileId: string,
    ): CancelablePromise<PatientFileDownloadUrlDto> {
        return __request({
            method: 'GET',
            path: `/referral/${referralId}/patient-files/${fileId}/download-url`,
        });
    }

}